/**
 * Copy text to clipboard with fallback for Android / non-secure contexts
 * where navigator.clipboard may be unavailable.
 */
export function copyToClipboard(text: string): void {
  // navigator.clipboard may be undefined on non-HTTPS Android browsers
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (navigator.clipboard?.writeText) {
    void navigator.clipboard.writeText(text).catch(() => {
      fallbackCopy(text);
    });
  } else {
    fallbackCopy(text);
  }
}

function fallbackCopy(text: string): void {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  // execCommand is deprecated but is the only fallback for non-secure contexts
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  document.execCommand('copy');
  document.body.removeChild(textarea);
}
